import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";
import { getButtonLoadingStyles } from "../styled/getButtonLoadingStyles";
import { ursaPadding } from "../styled/getButtonPadding";
import { mapButtonAppearance } from "../styled/mapButtonAppearance";
const getMargin = (hasLeftIcon, hasRightIcon, appearance, size) => {
  switch (appearance) {
    // For Lodestar buttons.
    case "borderless":
    case "primary":
    case "secondary":
    case "destructive":
    case "secondary-destructive":
    case "share":
      // Icons already provide a margin, so the content is only responsible for edges without an icon
      if (hasLeftIcon && hasRightIcon) {
        return {
          margin: `0`
        };
      }
      if (hasLeftIcon) {
        return {
          marginRight: `var(--sds--button--gap--${size}, ${sizes.small - 1}px)`
        }; // -1px for border
      }

      if (hasRightIcon) {
        return {
          marginLeft: `var(--sds--button--gap--${size}, ${sizes.small - 1}px)`
        };
      }
      // Proper spacing will be provided by the button padding if there are no icons present
      return {
        margin: `0`
      };
  }
};
const getPadding = (appearance, size, themeMode) => {
  const actualAppearance = mapButtonAppearance(appearance, themeMode);
  switch (actualAppearance) {
    // For Ursa buttons.
    case "primary-filled":
    case "primary-empty":
    case "secondary-filled":
    case "secondary-outlined":
    case "secondary-empty":
    case "canvas-filled":
    case "canvas-empty":
    case "destructive-filled":
    case "destructive-empty":
      return {
        paddingLeft: `var(--sds--button--gap--${size}, ${ursaPadding[size]})`,
        paddingRight: `var(--sds--button--gap--${size}, ${ursaPadding[size]})`
      };
  }
};
export const Content = styled("span")`
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${_ref => {
  let {
    isLoading
  } = _ref;
  return getButtonLoadingStyles(isLoading);
}};
    ${_ref2 => {
  let {
    hasLeftIcon,
    hasRightIcon,
    appearance,
    size,
    themeMode
  } = _ref2;
  return themeMode.includes("lodestar") && getMargin(hasLeftIcon, hasRightIcon, appearance, size);
}};
    ${_ref3 => {
  let {
    appearance,
    size,
    themeMode
  } = _ref3;
  return getPadding(appearance, size, themeMode);
}};
`;
//# sourceMappingURL=Content.js.map